import type { FaireProductEntity } from "../../entity_types/product";

export const p_6whc3pkpzz: FaireProductEntity = {
  token: "p_6whc3pkpzz",
  type: "product",
  name: "Amos Peelerz Pineapple Gummy Candy (3oz) (24-Pack)",
  brandToken: "b_qvgnvkj5hp",
  brandName: "AI Distribution",
  imageUrl:
    "https://cdn.faire.com/fastly/19e3903fb4f1b817a350ba9c49f907dd3f9cf8af9f09b1fa6081cda247a8ff0c.png",
  galleryImageUrls: [],
  priceDollars: 50.88,
  description:
    "Our Amos Peelerz Pineapple Gummy Candy is not your average snack. This 3oz pack of gummies from Gamer Bytes is designed with gamers in mind, providing a clean, energy-packed alternative to greasy snacks that can slow you down. Our pineapple gummy candy is bold in flavor, ensuring that even in the heat of the game, your snack is as exciting as your play. Enjoy a snack that works as hard as you do and never miss your gaming moment with our Amos Peelerz Pineapple Gummy Candy.",
  tags: [],
  msrpDollars: 101.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:27.271Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
